import type {
  IStAdjustmentsSummaryResponse,
  StAdjustmentsViewSummary,
} from "./types";

export const enrichStAdjustmentsSummary = (
  summary: IStAdjustmentsSummaryResponse | undefined,
  technicianNames: Map<number, string>,
): StAdjustmentsViewSummary | undefined =>
  summary
    ? {
        ...summary,
        by_technician: summary.by_technician.map((group) => ({
          ...group,
          technicianName:
            group.employee_id == null
              ? null
              : (technicianNames.get(group.employee_id) ?? null),
        })),
      }
    : undefined;
